export const trilingualModel = {
  title: "Modelo Trilíngue Progressivo",
  subtitle: "Imersão em inglês que cresce com cada etapa",
  stages: {
    infantil: {
      title: "Educação Infantil (3-6 anos)",
      percentage: "40%",
      description: "Introdução natural ao inglês em rotinas, jogos e atividades cotidianas"
    },
    cycle1: {
      title: "Primária Ciclo 1 (6-9 anos)",
      percentage: "45%",
      description: "Áreas não linguísticas como Science e Arts em inglês, consolidando a base comunicativa"
    },
    cycle2: {
      title: "Primária Ciclo 2 (9-12 anos)",
      percentage: "50%",
      description: "Metade do currículo em inglês, com fluência completa em contextos acadêmicos e sociais"
    }
  },
  footer: "Espanhol e Galego estão presentes em todas as etapas, garantindo o domínio das três línguas"
};
